import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 42.52 42.52"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.75 5.36c-8.32 0-15.08 6.77-15.08 15.08 0 2.04.4 4.01 1.18 5.86l-2.69 8.49 8.51-1.62c2.42 1.54 5.2 2.35 8.08 2.35 8.32 0 15.08-6.77 15.08-15.08S30.06 5.36 21.75 5.36Zm0 28.16c-2.62 0-5.15-.77-7.32-2.23l-.34-.23-6.02 1.14 1.91-6.02-.16-.35c-.77-1.7-1.16-3.51-1.16-5.4 0-7.21 5.87-13.08 13.08-13.08s13.08 5.87 13.08 13.08-5.87 13.08-13.08 13.08Z" }, null, -1),
    _createElementVNode("path", { d: "M22.95 24.68c-2.16-1.25-3.6-2.94-4.56-4.59l2.73-2.3-1.2-4.69h-5.46l.05 1.04c0 .13.74 12.96 14.37 14.43l1.11.12v-4.97l-4.23-1.17-2.81 2.13Zm-6.32-9.58h1.75l.5 1.97-1.38 1.17c-.49-1.24-.74-2.36-.87-3.13Zm11.36 10.14v1.19c-1.1-.18-2.1-.45-3-.79l1.19-.9 1.81.5Z" }, null, -1)
  ])))
}
export default { render: render }